import { render, staticRenderFns } from "./UserSpecPlan.vue?vue&type=template&id=224ab357"
import script from "./UserSpecPlan.vue?vue&type=script&lang=js"
export * from "./UserSpecPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports